export const styles = {
  bannerCloseIcon: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
  },
};
